import React, { useEffect, useState } from 'react';
import { Row, Spinner, Col, Card, Container, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import Layout from "../../layout/default";
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FaSearch } from "react-icons/fa";

const ComboListPage = () => {
  const { categoryId } = useParams();
  const [suggestedCombos, setSuggestedCombos] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(12); // Set to 1 for testing
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      Swal.fire({
        icon: "warning",
        title: "Authentication Required",
        text: "Please log in to proceed.",
      }).then(() => {
        navigate("/shop/auths/login", { replace: true });
      });
    }
  }, [navigate]);

  const fetchSuggestedCombos = () => {
    setLoading(true);
    const authToken = localStorage.getItem("authToken");
    // Show loading Swal with SVG image (auto-close in 5 seconds)
    // Swal.fire({
    //   title: 'Loading...',
    //   imageUrl: '/shop/images/Loading-time.svg',
    //   imageWidth:  '100%',
    //   imageHeight:'auto',
    //   imageAlt: 'Loading',
    //   showConfirmButton: false,
    //   allowOutsideClick: false,
    //   allowEscapeKey: false,
    //   backdrop: true,
    //   timer: 3000,
    //   timerProgressBar: true,
    // });
    axios.get(`${process.env.REACT_APP_HOST}api/usercombos/${categoryId}`, {
      headers: { Authorization: `Bearer ${authToken}` },
      params: {
        offset: offset,
        limit: limit,
        search: ''
      },
    })
      .then((response) => {
        const data = response.data.data;
        setSuggestedCombos((prev) => [...prev, ...data.combos]);

        // FIXED: Proper numeric increment
        setOffset(prevOffset => {
          const newOffset = Number(prevOffset) + Number(data.pagination.limit);
          console.log(`Updating offset from ${prevOffset} to ${newOffset}`);
          return newOffset;
        });

        setHasMore(data.pagination.has_more);
      })
      .catch((error) => {
        console.error("Error fetching combos:", error);
        setHasMore(false);
        Swal.fire({
          imageUrl: "/shop/images/Failed_1.svg", // Replace with your image path
          imageWidth: 100,
          imageHeight: 100,
          imageAlt: "Error Image",
          text: 'Failed to load products.',
        });
      })
      .finally(() => setLoading(false));
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) return setSearchResults([]);
    setSearchLoading(true);
    const authToken = localStorage.getItem("authToken");
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOST}api/usercombos/${categoryId}`, {
        headers: { Authorization: `Bearer ${authToken}` },
        params: { search: searchQuery },
      });
      setSearchResults(response.data.data.combos);
    } catch (error) {
      console.error("Error searching combos:", error);
    } finally {
      setSearchLoading(false);
    }
  };

  const handleLoadMore = () => {
    if (!hasMore) return;
    fetchSuggestedCombos();
  };

  useEffect(() => {
    setSuggestedCombos([]);
    setOffset(0);
    setHasMore(true);
    setSearchResults([]);
    fetchSuggestedCombos();
  }, [categoryId]);

  return (
    <Layout title="Products">
      <Container fluid className="mt-4">
        <Row className="justify-content-center">
          <Col xs={12} lg={19} className="text-center">

            {searchQuery && (
              <>
                <h6>Search Results</h6>
                {searchLoading ? (
                  <div className="text-center py-3">
                  </div>
                ) : searchResults.length === 0 ? (
                  <p>No combos found for "<strong>{searchQuery}</strong>"</p>
                ) : (
                  <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <Row className="gx-3 gy-4 justify-content-center">
                      {searchResults.map((combo) => (
                        <Col key={`search-${combo.id}`} lg={4} md={6} xs={12} className="d-flex justify-content-center">
                          <Card
                            className="h-100 border-0"
                            style={{
                              width: '100%',
                              maxWidth: '430px',
                              height: '306px',
                              overflow: 'hidden'
                            }}
                          >
                            <a href={`/shop/combo/${combo.id}`} className="text-decoration-none position-relative">
                              <Card.Img
                                src={`${process.env.REACT_APP_HOST}storage/${combo.combo_image.image}`}
                                alt={combo.name}
                                className="card-img-top"
                                style={{
                                  width: '100%',
                                  height: '306px',
                                  objectFit: 'cover'
                                }}
                              />
                              <Card.Body
                                className="p-3 position-absolute bottom-0 start-0 w-100"
                                style={{
                                  transform: 'translateY(100%)',
                                  transition: 'all 0.3s',
                                  backgroundColor: '#15181B',
                                  zIndex: 2
                                }}
                              >
                                <Card.Title className="text-white">{combo.name}</Card.Title>
                                <Card.Title className="fs-6 text-white">Price: ₹{combo.price}</Card.Title>
                              </Card.Body>
                            </a>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                )}
              </>
            )}

            <h2 className="section__title title-animation text-capitalize rr-br-hidden-md mb-1">Products</h2>

            {loading && suggestedCombos.length === 0 ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2">Loading products...</p>
              </div>
            ) : (
              <Row className="gx-3 gy-4 justify-content-center">
                {suggestedCombos.map((combo) => (
                  <Col lg={4} md={6} xs={12} key={combo.id} className="d-flex justify-content-center">
                    <Card
                      className="h-100 border-0"
                      style={{
                        width: '100%',
                        maxWidth: '430px',
                        height: '306px',
                        overflow: 'hidden'
                      }}
                    >
                      <a
                        href={`/shop/combo/${combo.id}`}
                        className="text-decoration-none position-relative"
                      >
                        <Card.Img
                          src={`${process.env.REACT_APP_HOST}storage/${combo.combo_image.image}`}
                          alt={combo.name}
                          className="card-img-top"
                          style={{
                            width: '100%',
                            height: '306px',
                            objectFit: 'cover'
                          }}
                        />
                        <Card.Body
                          className="p-3 position-absolute bottom-0 start-0 w-100"
                          style={{
                            transform: 'translateY(100%)',
                            transition: 'all 0.3s',
                            backgroundColor: '#15181B',
                            zIndex: 2
                          }}
                        >
                          <Card.Title className="text-white">{combo.name}</Card.Title>
                          <Card.Title className="fs-6 text-white">Price: ₹{combo.price}</Card.Title>
                        </Card.Body>
                      </a>
                    </Card>
                    <style jsx>{`
                      .card:hover .icon__wrapper {
                        opacity: 1 !important;
                      }
                      .card:hover .card-body {
                        transform: translateY(0) !important;
                      }
                      .card:hover .position-absolute[style*="opacity: 0"] {
                        opacity: 0.8 !important;
                      }
                      .card:hover img {
                        transform: scale(1.05);
                      }
                      @media (max-width: 767.98px) {
                        .card {
                          height: 200px !important;
                        }
                        .card img {
                          height: 200px !important;
                        }
                      }
                    `}</style>
                  </Col>
                ))}
              </Row>
            )}

            {hasMore && !searchQuery && (
              <div className="text-center mt-4">
                <button
                  className="btn btn-outline-primary"
                  onClick={handleLoadMore}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Load More"}
                </button>
              </div>
            )}
          </Col>
        </Row>
      </Container>
      <br />
      <br />
      <br />
    </Layout>
  );
};

export default ComboListPage;